import React from 'react';
import {
  ChatRequestsListModalOverlay,
  ChatRequestsListModalContent,
  ChatRequestModalHeader,
  ChatRequestModalTitle,
  ChatRequestModalCloseButton,
  ChatRequestsList,
  ChatRequestItem,
  ChatRequestItemInfo,
  ChatRequestItemName,
  ChatRequestItemConnectId,
  ChatRequestItemActions,
  ChatRequestActionButton,
  EmptyRequestsMessage,
} from '../../../styles/UserWorkspacePageStyles';
import { useT } from '../../../LocaleContext';

const GroupInvitesModal = ({
  isOpen,
  onClose,
  invites,
  onAccept,
  onReject,
}) => {
  const t = useT();

  if (!isOpen) return null;

  return (
    <ChatRequestsListModalOverlay onClick={onClose}>
      <ChatRequestsListModalContent onClick={(e) => e.stopPropagation()}>
        <ChatRequestModalHeader>
          <div />
          <ChatRequestModalTitle>{t('modals.groupInvites')}</ChatRequestModalTitle>
          <ChatRequestModalCloseButton onClick={onClose}>
            ×
          </ChatRequestModalCloseButton>
        </ChatRequestModalHeader>
        <ChatRequestsList>
          {invites.length > 0 ? (
            invites.map((invite) => (
              <ChatRequestItem key={invite.invite_id}>
                <ChatRequestItemInfo>
                  <ChatRequestItemName>{invite.title || t('chat.group')}</ChatRequestItemName>
                  <ChatRequestItemConnectId>
                    {t('modals.invitedBy', { name: invite.invited_by_name || 'user' })}
                    {invite.invited_by_connect_id ? ` (${invite.invited_by_connect_id})` : ''}
                  </ChatRequestItemConnectId>
                </ChatRequestItemInfo>
                <ChatRequestItemActions>
                  <ChatRequestActionButton
                    variant="accept"
                    onClick={() => onAccept(invite.invite_id)}
                  >
                    {t('common.accept')}
                  </ChatRequestActionButton>
                  <ChatRequestActionButton
                    variant="reject"
                    onClick={() => onReject(invite.invite_id)}
                  >
                    {t('common.reject')}
                  </ChatRequestActionButton>
                </ChatRequestItemActions>
              </ChatRequestItem>
            ))
          ) : (
            <EmptyRequestsMessage>{t('modals.noGroupInvites')}</EmptyRequestsMessage>
          )}
        </ChatRequestsList>
      </ChatRequestsListModalContent>
    </ChatRequestsListModalOverlay>
  );
};

export default GroupInvitesModal;
